import {
    DAY, MONTH, WEEK, YEAR,
} from './intervalTypes';

const maxIntervalCount = {
    [DAY]: 365,
    [WEEK]: 52,
    [MONTH]: 12,
    [YEAR]: 1,

};

export default maxIntervalCount;



// WEBPACK FOOTER //
// ./src/sources/constants/maxIntervalCounts.js